import React from "react";

function HeaderContact() {
  return (
    <div>
      <header className="header-contact">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mt- wow animate__animated animate__fadeInDown">
              <h2 className="text-white mt-3">تواصل معنا</h2>
              <p className="text-white">
                يسعدنا التواصل معكم علي جميع الاستفسارات
              </p>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default HeaderContact;
